// extracted by mini-css-extract-plugin
module.exports = {"heading":"target-stations-columns_heading__1zS74"};